<div class="conversation-list">
  <!-- Search bar -->
  <div class="search-bar">
    <input
      type="text"
      placeholder="Search User"
      [ngModel]="searchText()"
      (ngModelChange)="onSearch($event)"
      autocomplete="off" />
    <svg class="search-icon" viewBox="0 0 24 24" width="18" height="18" fill="#999">
      <path d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
    </svg>
  </div>

  <!-- Thread list -->
  <div class="thread-list">
    @for (thread of filteredThreads(); track thread.threadId) {
      <button
        class="convo-row"
        [class.active]="thread.threadId === activeThreadId()"
        (click)="threadSelected.emit(thread.threadId)">

        @if (thread.unreadCount > 0) {
          <span class="unread-dot"></span>
        }

        <span class="initials-avatar">{{ participantInitials(thread) }}</span>

        <div class="convo-body">
          <div class="top-row">
            <span class="convo-name">{{ otherNames(thread) || thread.topic }}</span>
            <span class="convo-time">{{ formatDateTime(thread) }}</span>
          </div>
          <div class="bottom-row">
            <span class="convo-preview">{{ lastMessagePreview(thread) }}</span>
          </div>
        </div>
      </button>
    } @empty {
      <p class="empty-hint">
        @if (searchText()) {
          No conversations match "{{ searchText() }}"
        } @else {
          No conversations yet. Tap the + button to start one.
        }
      </p>
    }
  </div>
</div>
